//Regex
export const emailRegex = "^[a-z0-9._%+-]+(@[a-z0-9.-]{1,})+\\.([a-z]{2,4}$)"
export const namRegex = "(^([A-Z][A-Z][A-Z][A-Z|*][0-9][0-9][0156][0-9][0-3][0-9]([A-Z]|[0-9])[0-9]$)|(^[0-9]{9}[M]{0,1}$)|(^[0-9]{10}$))";
export const loginRegex = "(^[a-zA-Z0-9_@.]{6,30}$)";
export const passwordRegex = "^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[^A-Za-z0-9_]).{10,40}"
export const phoneRegex = "[- +()0-9]{10,14}"
export const phone11Regex = "[0-9]{10,11}"
export const postalRegex = "^[ABCEGHJ-NPRSTVXY][0-9][ABCEGHJ-NPRSTV-Z][ ]?[0-9][ABCEGHJ-NPRSTV-Z][0-9]$"
//"^[0-9]{3}[\\s.-][0-9]{3}[\\s.-][0-9]{4}"

export class EditableDataObject{
	modificationStatus : ModificationStatus = ModificationStatus.STATUS_NEUTRAL;
	version? : number;
}

export enum ModificationStatus{
	STATUS_CHILDREN_UPDATED="STATUS_CHILDREN_UPDATED", 
	STATUS_DELETED="STATUS_DELETED", 
	STATUS_NEUTRAL="STATUS_NEUTRAL", 
	STATUS_NEW="STATUS_NEW", 
	STATUS_NEW_UPDATED="STATUS_NEW_UPDATED",
	/**
	 * object was deleted when it was new or new updated 
	 */
	STATUS_NON_EXISTING="STATUS_NON_EXISTING",
	STATUS_UPDATED="STATUS_UPDATED", 
	STATUS_UPDATED_ORDER="STATUS_UPDATED_ORDER"
}